module.exports = __webpack_public_path__ + "static/media/icon_user2.78ac14a0.png";